import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { initI18n, format } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { cityIn } from 'lvovich';
import { getDurationString } from '../../../Results/utils';
initI18n('FlightInfoCardHint');
export var hintType;
(function (hintType) {
    hintType["Warning"] = "Warning";
    hintType["Info"] = "Info";
    hintType["Promo"] = "Promo";
    hintType["StopHint"] = "StopHint";
})(hintType || (hintType = {}));
const FlightInfoCardHint = ({ type, segment, text, isVisible }) => {
    const { FlightInfoCardHint: css } = useTheme('FlightInfoCard');
    const { t } = useTranslation(['FlightInfoCard', 'DesktopFlightInfo']);
    return (React.createElement("div", { className: cn(css.wrapper, {
            [css.wrapper_info]: type === hintType.Info,
            [css.wrapper_warning]: type === hintType.Warning,
            [css.wrapper_promo]: type === hintType.Promo,
            [css.wrapper_stophint]: type === hintType.StopHint
        }) },
        type === hintType.Warning &&
            t('Online checkin opens {{date}}', {
                date: format(segment.arrival.date, 'dd MMM yyyy')
            }),
        type === hintType.StopHint && (React.createElement("div", { className: cn(css.stopHint) },
            React.createElement("div", null,
                React.createElement("span", null, t('TechnicalLandingIn', {
                    ns: 'DesktopFlightInfo',
                    count: segment.stops.length
                })),
                ' ',
                React.createElement("span", null, segment.stops
                    .map(stop => { var _a, _b; return `${cityIn((_b = (_a = stop === null || stop === void 0 ? void 0 : stop.airport) === null || _a === void 0 ? void 0 : _a.city) === null || _b === void 0 ? void 0 : _b.name)} – ${getDurationString(stop.duration)}`; })
                    .join(', '))))),
        type === hintType.Info && t('Time in route {{time}}', { time: text })));
};
export default FlightInfoCardHint;
